import "../scss/main.scss";
import "flatpickr/dist/flatpickr.min.css";
import ApexCharts, {
    registerFeatures
} from 'apexcharts';
import flatpickr from "flatpickr";
import {
    Polish
} from "flatpickr/dist/l10n/pl.js";
import GLightbox from 'glightbox';
import AOS from 'aos';
import 'aos/dist/aos.css';

(function ($) {

    $(document).ready(function () {
        theme.init()
    });

    var theme = {
        init: function () {
            AOS.init({
                once: true,
                duration: 800,
                offset: 50,
            });

            const refreshAOS = () => {
                AOS.refresh();
            };

            window.addEventListener('load', refreshAOS);

            if (document.readyState === 'complete') {
                refreshAOS();
            }

            this.opinieSlider();
            this.menuSubmenuShow();
            this.wiedzaAjax();
            this.inicjatywaAjax();
            this.wpisyAjax();
            this.celeAjax();
            this.partnerzyAjax();
            this.charts();
            this.agendaGoals();
            this.menuMobile();
            this.downButton();
            this.partnersCarousel();
            this.navLinkPost();
            this.showMoreText();
            this.eskperciSlider();
            this.drawConnections();
            this.opinieCarousel();
            this.historyTabs();
            this.drawExpertiseConnections();
            this.sharePost();
            this.kreatorEksperciSlider();
            this.eventsAjax();
            this.momentsSlider();
            this.popupArchive();
            this.initiativesTabs();
            this.initiativesCarousel();
            this.emailData();
            this.popupDesc();
            this.navLinkSide();
            this.tabLogin();
            this.celSlider();
            this.celChartsSlider();
            this.heroHomeSlider();
            this.leadBottomSlider();
            this.supportSlider();
            this.postsSlider();
            this.popupIntegration();
            this.popupHero();
            this.registerBoxes();
            this.accountMenu();
            this.footerMenuMobile();
            this.initLightbox();
            this.popupWiedzaPost();
            this.popupWydarzeniePost();
            this.popupInicjatywaPost();
            this.knowledgePopup();
            this.popupKnowledge();
            this.relatedCeleSlider();
            this.initAccessibility();
        },

        
        relatedCeleSlider: function () {
            const $container = $('.related-cele-container');
            if ($container.length > 0 && $container.children().length > 3) {
                $container.slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 3000,
                    arrows: false,
                    dots: false
                });
            }
        },

        knowledgePopup: function(){
const $body = $('body');

            if ($('#knowledge-global-modal').length === 0) {
                $body.append(`
                        <div id="knowledge-global-modal" role="dialog" aria-modal="true" tabindex="-1" class="modal-overlay position-fixed top-0 start-0 w-100 h-100 d-none justify-content-center align-items-center" style="z-index: 99999999999999; background: rgba(0,0,0,0.75); backdrop-filter: blur(4px);">
                            <div class="bg-white rounded-4 position-relative w-100 mx-3 d-flex flex-column shadow-lg" style="max-width: 828px; max-height: 95vh;">
                                <button type="button" class="btn-close position-absolute top-0 end-0 m-4 js-close-knowledge-modal" aria-label="Close" style="z-index: 10;"></button>
                                <div class="modal-body text-modal overflow-auto p-3 p-lg-4">
                                    <div class="knowledge-details-content"></div>
                                </div>
                            </div>
                        </div>
                    `);
            }

            const $modal = $('#knowledge-global-modal');
            const $modalContent = $modal.find('.knowledge-details-content');

            $('.js-open-knowledge-popup').on('click', function (e) {
                e.preventDefault();
                const targetId = $(this).data('target');
                const $sourceBlock = $('#' + targetId);

                if ($sourceBlock.length) {
                    $sourceBlock.removeClass('d-none');

                    const placeholderId = 'knowledge-placeholder-' + targetId;
                    if ($('#' + placeholderId).length === 0) {
                        $sourceBlock.before('<div id="' + placeholderId + '" class="d-none"></div>');
                    }

                    $modalContent.empty().append($sourceBlock);
                    $modal.removeClass('d-none').css('display', 'flex').hide().fadeIn(300);
                    $body.css('overflow', 'hidden');
                }
            });

            const closeModal = function () {
                $modal.fadeOut(300, function () {
                    $(this).addClass('d-none').css('display', '');
                    const $movedBlock = $modalContent.children().first();
                    if ($movedBlock.length) {
                        const originalId = $movedBlock.attr('id');
                        $movedBlock.addClass('d-none');
                        $('#knowledge-placeholder-' + originalId).replaceWith($movedBlock);
                    }
                    $modalContent.empty();
                    $body.css('overflow', '');
                });
            };

            $(document).on('click', '.js-close-knowledge-modal', closeModal);

            $modal.on('click', function (e) {
                if ($(e.target).is($modal)) {
                    closeModal();
                }
            });
        },

        popupWiedzaPost: function () {
            const $body = $('body');

            if ($('#wiedza-global-modal').length === 0) {
                $body.append(`
                    <div id="wiedza-global-modal" role="dialog" aria-modal="true" tabindex="-1" class="modal-overlay position-fixed top-0 start-0 w-100 h-100 d-none justify-content-center align-items-center" style="z-index: 99999999999999; background: rgba(0,0,0,0.75); backdrop-filter: blur(4px);">
                        <div class="bg-white rounded-4 position-relative w-100 mx-3 d-flex flex-column shadow-lg" style="max-width: 828px; max-height: 95vh;">
                            <button type="button" class="btn-close position-absolute top-0 end-0 m-4 js-close-wiedza-modal" aria-label="Close" style="z-index: 10;"></button>
                            <div class="modal-body text-modal overflow-auto p-3 p-lg-4">
                                <div class="wiedza-details-content"></div>
                            </div>
                        </div>
                    </div>
                `);
            }

            const $modal = $('#wiedza-global-modal');
            const $modalContent = $modal.find('.wiedza-details-content');

            $('.js-open-wiedza-popup').on('click', function (e) {
                e.preventDefault();
                const targetId = $(this).data('target');
                const $sourceBlock = $('#' + targetId);

                if ($sourceBlock.length) {
                    $sourceBlock.removeClass('d-none');

                    const placeholderId = 'wiedza-placeholder-' + targetId;
                    if ($('#' + placeholderId).length === 0) {
                        $sourceBlock.before('<div id="' + placeholderId + '" class="d-none"></div>');
                    }

                    $modalContent.empty().append($sourceBlock);
                    $modal.removeClass('d-none').css('display', 'flex').hide().fadeIn(300);
                    $body.css('overflow', 'hidden');
                }
            });

            const closeModal = function () {
                $modal.fadeOut(300, function () {
                    $(this).addClass('d-none').css('display', '');
                    const $movedBlock = $modalContent.children().first();
                    if ($movedBlock.length) {
                        const originalId = $movedBlock.attr('id');
                        $movedBlock.addClass('d-none');
                        $('#wiedza-placeholder-' + originalId).replaceWith($movedBlock);
                    }
                    $modalContent.empty();
                    $body.css('overflow', '');
                });
            };

            $(document).on('click', '.js-close-wiedza-modal', closeModal);

            $modal.on('click', function (e) {
                if ($(e.target).is($modal)) {
                    closeModal();
                }
            });
        },

        initLightbox: function () {
            const lightbox = GLightbox({
                selector: '.lightbox-trigger',
                touchNavigation: true,
                loop: true
            });
        },

        footerMenuMobile: function () {
            const footerMenuColumns = document.querySelectorAll('.footer-menu-column');

            footerMenuColumns.forEach(column => {
                column.addEventListener('click', function () {
                    const ul = this.querySelector('ul');
                    if (ul) {
                        ul.classList.toggle('active');
                    }
                });
            });
        },

        accountMenu: function () {
            const button = document.querySelector('.account-button .btn');
            const menu = document.querySelector('.account-menu');

            if (button && menu) {
                button.addEventListener('click', (event) => {
                    event.stopPropagation();
                    menu.classList.toggle('active');
                });

                document.addEventListener('click', (event) => {
                    if (!menu.contains(event.target) && !button.contains(event.target)) {
                        menu.classList.remove('active');
                    }
                });
            }
        },

        registerBoxes: function () {
            const toggleButtons = document.querySelectorAll('.box-link');
            toggleButtons.forEach(button => {
                button.addEventListener('click', function () {
                    const container = this.closest('.col-lg-6');
                    const textContent = container.querySelector('.box-hidden-text');

                    if (textContent) {
                        textContent.classList.toggle('is-open');
                        this.classList.toggle('is-active');
                    }
                });
            });
        },

        popupHero: function () {
            const $body = $('body');

            if ($('#hero-global-modal').length === 0) {
                $body.append(`
                        <div id="hero-global-modal" role="dialog" aria-modal="true" tabindex="-1" class="modal-overlay position-fixed top-0 start-0 w-100 h-100 d-none justify-content-center align-items-center" style="z-index: 99999999999999; background: rgba(0,0,0,0.75); backdrop-filter: blur(4px);">
                            <div class="bg-white rounded-4 position-relative w-100 mx-3 d-flex flex-column shadow-lg" style="max-width: 828px; max-height: 95vh;">
                                <button type="button" class="btn-close position-absolute top-0 end-0 m-4 js-close-hero-modal" aria-label="Close" style="z-index: 10;"></button>
                                <div class="modal-body text-modal overflow-auto p-3 p-lg-4">
                                    <div class="hero-details-content"></div>
                                </div>
                            </div>
                        </div>
                    `);
            }

            const $modal = $('#hero-global-modal');
            const $modalContent = $modal.find('.hero-details-content');

            $('.js-open-hero-popup').on('click', function (e) {
                e.preventDefault();
                const targetId = $(this).data('target');
                const $sourceBlock = $('#' + targetId);

                if ($sourceBlock.length) {
                    $sourceBlock.removeClass('d-none');

                    const placeholderId = 'hero-placeholder-' + targetId;
                    if ($('#' + placeholderId).length === 0) {
                        $sourceBlock.before('<div id="' + placeholderId + '" class="d-none"></div>');
                    }

                    $modalContent.empty().append($sourceBlock);
                    $modal.removeClass('d-none').css('display', 'flex').hide().fadeIn(300);
                    $body.css('overflow', 'hidden');
                }
            });

            const closeModal = function () {
                $modal.fadeOut(300, function () {
                    $(this).addClass('d-none').css('display', '');
                    const $movedBlock = $modalContent.children().first();
                    if ($movedBlock.length) {
                        const originalId = $movedBlock.attr('id');
                        $movedBlock.addClass('d-none');
                        $('#hero-placeholder-' + originalId).replaceWith($movedBlock);
                    }
                    $modalContent.empty();
                    $body.css('overflow', '');
                });
            };

            $(document).on('click', '.js-close-hero-modal', closeModal);

            $modal.on('click', function (e) {
                if ($(e.target).is($modal)) {
                    closeModal();
                }
            });
        },

        popupIntegration: function () {
            const $body = $('body');

            if ($('#integration-global-modal').length === 0) {
                $body.append(`
                        <div id="integration-global-modal" role="dialog" aria-modal="true" tabindex="-1" class="modal-overlay position-fixed top-0 start-0 w-100 h-100 d-none justify-content-center align-items-center" style="z-index: 99999999999999; background: rgba(0,0,0,0.75); backdrop-filter: blur(4px);">
                            <div class="bg-white rounded-4 position-relative w-100 mx-3 d-flex flex-column shadow-lg" style="max-width: 828px; max-height: 95vh;">
                                <button type="button" class="btn-close position-absolute top-0 end-0 m-4 js-close-integration-modal" aria-label="Close" style="z-index: 10;"></button>
                                <div class="modal-body text-modal overflow-auto p-3 p-lg-4">
                                    <div class="integration-details-content"></div>
                                </div>
                            </div>
                        </div>
                    `);
            }

            const $modal = $('#integration-global-modal');
            const $modalContent = $modal.find('.integration-details-content');

            $('.js-open-integration-popup').on('click', function (e) {
                e.preventDefault();
                const targetId = $(this).data('target');
                const $sourceBlock = $('#' + targetId);

                if ($sourceBlock.length) {
                    $sourceBlock.removeClass('d-none');

                    const placeholderId = 'integration-placeholder-' + targetId;
                    if ($('#' + placeholderId).length === 0) {
                        $sourceBlock.before('<div id="' + placeholderId + '" class="d-none"></div>');
                    }

                    $modalContent.empty().append($sourceBlock);
                    $modal.removeClass('d-none').css('display', 'flex').hide().fadeIn(300);
                    $body.css('overflow', 'hidden');
                }
            });

            const closeModal = function () {
                $modal.fadeOut(300, function () {
                    $(this).addClass('d-none').css('display', '');
                    const $movedBlock = $modalContent.children().first();
                    if ($movedBlock.length) {
                        const originalId = $movedBlock.attr('id');
                        $movedBlock.addClass('d-none');
                        $('#integration-placeholder-' + originalId).replaceWith($movedBlock);
                    }
                    $modalContent.empty();
                    $body.css('overflow', '');
                });
            };

            $(document).on('click', '.js-close-integration-modal', closeModal);

            $modal.on('click', function (e) {
                if ($(e.target).is($modal)) {
                    closeModal();
                }
            });
        },

        postsSlider: function () {
            $('.posts-slick-slider').each(function () {
                let $slider = $(this);
                let $wrapper = $slider.closest('.tab-pane');
                let $prev = $wrapper.find('.tab-slider-prev-btn');
                let $next = $wrapper.find('.tab-slider-next-btn');
                let $dots = $wrapper.find('.tab-slider-dots');

                $slider.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    prevArrow: $prev,
                    nextArrow: $next,
                    infinite: false,
                    dots: true,
                    appendDots: $dots,
                    adaptiveHeight: true,
                    customPaging: function (slider, i) {
                        return '<button class="border-0 rounded-circle" style="width: 12px; height: 12px; background-color: #d3d3d3; margin: 0 4px; padding: 0; transition: 0.3s;"></button>';
                    }
                });

                $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                    $dots.find('li button').css('background-color', '#d3d3d3');
                    $dots.find('li').eq(nextSlide).find('button').css('background-color', '#EB6411');
                });

                $dots.find('li.slick-active button').css('background-color', '#EB6411');
            });

            $('button[data-bs-toggle="pill"]').on('shown.bs.tab', function (e) {
                $('.posts-slick-slider').slick('setPosition');
            });
        },

        supportSlider: function () {
            var $slider = $('.support-slider');
            var $prev = $('.support-prev');
            var $next = $('.support-next');

            if ($slider.length) {
                $slider.slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    prevArrow: $prev,
                    nextArrow: $next,
                    loop: true,
                    arrows: true,
                    responsive: [{
                        breakpoint: 1249,
                        settings: {
                            slidesToShow: 2
                        }
                    }]
                });
            }
        },

        celChartsSlider: function () {
            var $slider = $('.cel-charts-slider');
            if ($slider.length === 0) return;

            function initCelSlider() {
                if ($(window).width() < 768) {
                    if (!$slider.hasClass('slick-initialized')) {
                        $slider.slick({
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                            dots: true,
                            infinite: true,
                            autoplay: true,
                            autoplaySpeed: 3000
                        });
                    }
                } else {
                    if ($slider.hasClass('slick-initialized')) {
                        $slider.slick('unslick');
                    }
                }
            }

            initCelSlider();
            $(window).on('resize', initCelSlider);
        },

        heroHomeSlider: function () {
            var $slider = $('.hero-home-slider');
            if ($slider.length === 0) return;

            function initHeroSlider() {
                if ($(window).width() < 768) {
                    if (!$slider.hasClass('slick-initialized')) {
                        $slider.slick({
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                            dots: false,
                            infinite: true,
                            autoplay: true,
                            autoplaySpeed: 3000
                        });
                    }
                } else {
                    if ($slider.hasClass('slick-initialized')) {
                        $slider.slick('unslick');
                    }
                }
            }

            initHeroSlider();
            $(window).on('resize', initHeroSlider);
        },

        leadBottomSlider: function () {
            var $slider = $('.lead-bottom-slider');
            if ($slider.length === 0) return;

            function initLeadSlider() {
                if ($(window).width() < 768) {
                    if (!$slider.hasClass('slick-initialized')) {
                        $slider.slick({
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                            dots: false,
                            infinite: true,
                            autoplay: true,
                            autoplaySpeed: 3000
                        });
                    }
                } else {
                    if ($slider.hasClass('slick-initialized')) {
                        $slider.slick('unslick');
                    }
                }
            }

            initLeadSlider();
            $(window).on('resize', initLeadSlider);
        },

        celSlider: function () {
            var $slider = $('.cele-slider');
            var $prev = $('.slider-prev');
            var $next = $('.slider-next');

            if ($slider.length) {
                $slider.on('init', function (event, slick) {
                    setTimeout(function () {
                        updateActiveSlide(slick.$slider, slick);
                    }, 50);
                });

                $slider.slick({
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    centerMode: false,
                    prevArrow: $prev,
                    nextArrow: $next,
                    variableWidth: true,
                    autoplay: true,
                    autoplaySpeed: 3000,
                    arrows: true,
                    responsive: [{
                            breakpoint: 1750,
                            settings: {
                                slidesToShow: 5
                            }
                        },
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 3
                            }
                        },
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 4,
                                variableWidth: false
                            }
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 3,
                                variableWidth: false
                            }
                        }
                    ]
                });

                function updateArrowColors($activeSlide) {
                    var currentIndex = $activeSlide.data('slick-index');
                    var $allSlides = $slider.find('.slick-slide:not(.slick-cloned)');
                    var count = $allSlides.length;

                    var normalizedIndex = currentIndex % count;
                    if (normalizedIndex < 0) {
                        normalizedIndex += count;
                    }

                    var prevIndex = (normalizedIndex - 1 + count) % count;
                    var nextIndex = (normalizedIndex + 1) % count;

                    var $prevSlide = $slider.find('.slick-slide[data-slick-index="' + prevIndex + '"]').first();
                    var $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextIndex + '"]').first();

                    var prevColor = $prevSlide.data('color');
                    var nextColor = $nextSlide.data('color');

                    if (prevColor) {
                        $prev.find('rect').attr('fill', prevColor);
                    }
                    if (nextColor) {
                        $next.find('rect').attr('fill', nextColor);
                    }
                }

                function updateActiveSlide($sliderEl, slick) {
                    var currentSlidesToShow = slick.options.slidesToShow;
                    var targetIndex = 3;

                    if (currentSlidesToShow === 4) {
                        targetIndex = 1;
                    } else if (currentSlidesToShow === 3) {
                        targetIndex = 1;
                    } else if (currentSlidesToShow <= 2) {
                        targetIndex = 1;
                    }

                    var $activeSlides = $sliderEl.find('.slick-active');
                    var $targetSlide = $($activeSlides[targetIndex]);

                    if (!$targetSlide.length) {
                        $targetSlide = $($activeSlides[currentSlidesToShow - 1]);
                    }

                    $sliderEl.find('.slick-slide').removeClass('active');

                    if ($targetSlide.length) {
                        $targetSlide.addClass('active');
                        updateArrowColors($targetSlide);
                    }
                }

                $slider.on('afterChange breakpoint', function (event, slick) {
                    updateActiveSlide(slick.$slider, slick);
                });
            }
        },

        tabLogin: function () {
            const $wrapper = $('.auth-tabs-wrapper');

            if (!$wrapper.length) return;

            if ($wrapper.find('.nav-item:first-child .nav-link').hasClass('active')) {
                $wrapper.addClass('first-active');
            }

            const tabElements = document.querySelectorAll('.auth-tabs-wrapper button[data-bs-toggle="tab"]');

            tabElements.forEach(function (tabEl) {
                tabEl.addEventListener('shown.bs.tab', function (event) {
                    const $activeTab = $(event.target);
                    const index = $activeTab.closest('.nav-item').index();

                    if (index === 0) {
                        $wrapper.addClass('first-active');
                    } else {
                        $wrapper.removeClass('first-active');
                    }
                });
            });
        },

        navLinkSide: function () {
            const $navTop = $('.nav-side');
            const $navLinks = $('#inicjatywa-menu .nav-link');

            if ($navTop.length === 0 || $navLinks.length === 0) return;

            $navLinks.on('click', function (e) {
                e.preventDefault();
                const targetId = $(this).attr('href');

                if (targetId === "#") return;

                const $targetSection = $(targetId);

                if ($targetSection.length) {
                    $('html, body').animate({
                        scrollTop: $targetSection.offset().top - 110
                    }, 400);
                }
            });

            $(window).on('scroll', function () {
                const windowScrollTop = $(window).scrollTop();
                const scrollPos = windowScrollTop + 150;

                $navLinks.each(function () {
                    const $currLink = $(this);
                    const targetHref = $currLink.attr("href");

                    if (targetHref === "#") return;

                    const $refElement = $(targetHref);

                    if ($refElement.length) {
                        const refElementTop = $refElement.offset().top;
                        const refElementBottom = refElementTop + $refElement.outerHeight();

                        if (refElementTop <= scrollPos && refElementBottom > scrollPos) {
                            $navLinks.removeClass("active");
                            $currLink.addClass("active");
                        } else {
                            $currLink.removeClass("active");
                        }
                    }
                });
            });

            $(window).trigger('scroll');
        },

        popupDesc: function () {
            const $body = $('body');

            if ($('#desc-global-modal').length === 0) {
                $body.append(`
                    <div id="desc-global-modal" role="dialog" aria-modal="true" tabindex="-1" class="modal-overlay position-fixed top-0 start-0 w-100 h-100 d-none justify-content-center align-items-center" style="z-index: 99999999999999; background: rgba(0,0,0,0.75); backdrop-filter: blur(4px);">
                        <div class="bg-white rounded-4 position-relative w-100 mx-3 d-flex flex-column shadow-lg" style="max-width: 828px; max-height: 95vh;">
                            <button type="button" class="btn-close position-absolute top-0 end-0 m-4 js-close-desc-modal" aria-label="Close" style="z-index: 10;"></button>
                            <div class="modal-body text-modal overflow-auto p-3 p-lg-4">
                                <div class="desc-details-content"></div>
                            </div>
                        </div>
                    </div>
                `);
            }

            const $modal = $('#desc-global-modal');
            const $modalContent = $modal.find('.desc-details-content');

            $('.js-open-desc-popup').on('click', function (e) {
                e.preventDefault();
                const targetId = $(this).data('target');
                const $sourceBlock = $('#' + targetId);

                if ($sourceBlock.length) {
                    $sourceBlock.removeClass('d-none');

                    const placeholderId = 'desc-placeholder-' + targetId;
                    if ($('#' + placeholderId).length === 0) {
                        $sourceBlock.before('<div id="' + placeholderId + '" class="d-none"></div>');
                    }

                    $modalContent.empty().append($sourceBlock);
                    $modal.removeClass('d-none').css('display', 'flex').hide().fadeIn(300);
                    $body.css('overflow', 'hidden');
                }
            });

            const closeModal = function () {
                $modal.fadeOut(300, function () {
                    $(this).addClass('d-none').css('display', '');
                    const $movedBlock = $modalContent.children().first();
                    if ($movedBlock.length) {
                        const originalId = $movedBlock.attr('id');
                        $movedBlock.addClass('d-none');
                        $('#desc-placeholder-' + originalId).replaceWith($movedBlock);
                    }
                    $modalContent.empty();
                    $body.css('overflow', '');
                });
            };

            $(document).on('click', '.js-close-desc-modal', closeModal);

            $modal.on('click', function (e) {
                if ($(e.target).is($modal)) {
                    closeModal();
                }
            });
        },

        emailData: function () {
            const emailElements = document.querySelectorAll('[email-data]');
            emailElements.forEach(element => {
                element.addEventListener('click', function () {
                    const emailAddress = this.getAttribute('email-data');

                    if (emailAddress) {
                        navigator.clipboard.writeText(emailAddress).then(() => {
                            console.log('Skopiowano: ' + emailAddress);
                        }).catch(err => {
                            console.error('Błąd kopiowania: ', err);
                        });
                    }
                });
            });
        },

        initiativesCarousel: function () {
            const $slider = $('.inicjatywa-slider-container');
            if ($slider.length && !$slider.hasClass('slick-initialized')) {
                $slider.slick({
                    rows: 3,
                    slidesPerRow: 3,
                    arrows: true,
                    prevArrow: $('.initiative-prev-btn'),
                    nextArrow: $('.initiative-next-btn'),
                    dots: true,
                    adaptiveHeight: true,
                    appendDots: $('.initiatives-dots'),
                    customPaging: function (slider, i) {
                        return '<button type="button" class="border-0 rounded-circle"></button>';
                    },
                    responsive: [{
                            breakpoint: 992,
                            settings: {
                                rows: 3,
                                slidesPerRow: 2
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                rows: 3,
                                slidesPerRow: 1
                            }
                        }
                    ]
                });
            }
        },

        initiativesTabs: function () {
            const tabs = document.querySelectorAll('#custom-tabs .tab-title');
            const panes = document.querySelectorAll('.tabs-content .tab-pane');

            tabs.forEach(function (tab) {
                tab.addEventListener('click', function () {
                    tabs.forEach(function (t) {
                        t.classList.remove('active');
                    });
                    panes.forEach(function (p) {
                        p.classList.remove('active');
                        p.style.display = 'none';
                    });

                    this.classList.add('active');
                    const targetId = this.getAttribute('data-tab');
                    const activePane = document.getElementById(targetId);

                    if (activePane) {
                        activePane.classList.add('active');
                        activePane.style.display = 'block';
                    }
                });
            });
        },

        popupArchive: function () {
            const $body = $('body');

            if ($('#archive-global-modal').length === 0) {
                $body.append(`
                <div id="archive-global-modal" role="dialog" aria-modal="true" tabindex="-1" class="modal-overlay position-fixed top-0 start-0 w-100 h-100 d-none justify-content-center align-items-center" style="z-index: 999999999; background: rgba(0,0,0,0.75); backdrop-filter: blur(4px);">
                    <div class="bg-white rounded-4 position-relative w-100 mx-3 d-flex flex-column shadow-lg" style="max-width: 828px; max-height: 95vh;">
                        <button type="button" class="btn-close position-absolute top-0 end-0 m-4 js-close-archive-modal" aria-label="Close" style="z-index: 10;"></button>
                        <div class="modal-body text-modal overflow-auto p-3 p-lg-4">
                            <div class="details-content"></div>
                        </div>
                    </div>
                </div>
            `);
            }

            const $modal = $('#archive-global-modal');
            const $modalContent = $modal.find('.details-content');

            $('.js-open-archive-popup').on('click', function (e) {
                e.preventDefault();
                const targetId = $(this).data('target');
                const $sourceBlock = $('#' + targetId);

                if ($sourceBlock.length) {
                    const placeholderId = 'placeholder-' + targetId;
                    if ($('#' + placeholderId).length === 0) {
                        $sourceBlock.before('<div id="' + placeholderId + '" class="d-none"></div>');
                    }

                    $modalContent.empty().append($sourceBlock);
                    $modal.removeClass('d-none').css('display', 'flex').hide().fadeIn(300);
                    $body.css('overflow', 'hidden');
                }
            });

            const closeModal = function () {
                $modal.fadeOut(300, function () {
                    $(this).addClass('d-none').css('display', '');
                    const $movedBlock = $modalContent.children().first();
                    if ($movedBlock.length) {
                        const originalId = $movedBlock.attr('id');
                        $('#placeholder-' + originalId).replaceWith($movedBlock);
                    }
                    $modalContent.empty();
                    $body.css('overflow', '');
                });
            };

            $(document).on('click', '.js-close-archive-modal', closeModal);

            $modal.on('click', function (e) {
                if ($(e.target).is($modal)) {
                    closeModal();
                }
            });
        },

        momentsSlider: function () {
            $('.moments-slider').slick({
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                prevArrow: $('.moments-prev'),
                nextArrow: $('.moments-next'),
                dots: false,
                responsive: [{
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        },

        eventsAjax: function () {
            const $resultsContainer = $('.events-slider');
            const $searchBox = $('#events-search');
            const $navigationRow = $('.row.navigation');
            let debounceTimer;

            if (!$resultsContainer.length) return;

            const updateActiveClasses = () => {
                $('#events-filters label').removeClass('active');
                $('#events-filters input[type="checkbox"]:checked, #events-filters input[type="radio"]:checked').parent('label').addClass('active');

                let titlePrefixes = [];
                $('#events-filters input[name="kategoria_wydarzenia"]:checked').each(function() {
                    if ($(this).val() !== 'najnowsze') {
                        titlePrefixes.push($(this).parent('label').text().trim());
                    }
                });

                if (titlePrefixes.length > 0) {
                    $('#events-title-prefix').text(titlePrefixes.join(', '));
                } else {
                    $('#events-title-prefix').text('Najnowsze');
                }
            };



            let isCalendarInit = true;
            let calendarInstance = null;

            if (typeof flatpickr !== 'undefined') {
                calendarInstance = flatpickr("#events-calendar", {
                    inline: true,
                    locale: Polish,
                    mode: "multiple",
                    defaultDate: "today",
                    enable: typeof window.eventsConfig !== 'undefined' ? window.eventsConfig.dates : [],
                    onChange: function (selectedDates, dateStr, instance) {
                        if (selectedDates.length > 1) {
                            const lastDate = selectedDates[selectedDates.length - 1];
                            instance.setDate([lastDate], false);
                        }
                        if (isCalendarInit) return;
                        $('.event-najnowsze-trigger').prop('checked', false);
                        updateActiveClasses();
                        fetchEvents();
                    }
                });
                isCalendarInit = false;
            }

            const fetchEvents = (page = 1) => {
                const isNajnowszeChecked = $('.event-najnowsze-trigger').is(':checked');

                const getCheckedValues = (name) => {
                    return $(`input[name="${name}"]:checked`).map(function() {
                        return $(this).val();
                    }).get();
                };

                const data = {
                    action: 'filter_events',
                    search: $searchBox.val(),
                    kategoria: getCheckedValues('kategoria_wydarzenia'),
                    data: isNajnowszeChecked ? '' : $('#events-calendar').val(),
                    kontekst_cel: getCheckedValues('kontekst_cel[]'),
                    kontekst_branza: getCheckedValues('kontekst_branza[]'),
                    kontekst_tag: getCheckedValues('kontekst_tag[]'),
                    kontekst_partner: getCheckedValues('kontekst_partner[]'),
                    paged: page
                };

                $('#events-results-container').css('opacity', '0.5');

                $.ajax({
                    url: wiedza_vars.ajax_url,
                    type: 'POST',
                    data: data,
                    dataType: 'json',
                    success: function (response) {
                        $('.row.navigation').addClass('d-none').hide(); // Ukrywamy stary wiersz nawigacji
                        
                        if (response && response.success) {
                            $resultsContainer.html(response.data.html);

                            $('#ajax-wydarzenia-popups-wrapper').remove();
                            if (response.data.popups) {
                                $('body').append('<div id="ajax-wydarzenia-popups-wrapper" class="d-none">' + response.data.popups + '</div>');
                            }
                        } else {
                            $resultsContainer.html('<p class="text-center w-100 py-5">Wystąpił błąd podczas ładowania danych.</p>');
                        }
                    },
                    error: function (xhr, status, error) {
                        $('.row.navigation').addClass('d-none').hide();
                        $resultsContainer.html('<p class="text-center w-100 py-5 text-danger fw-bold">Błąd komunikacji z serwerem: ' + status + '</p>');
                    },
                    complete: function () {
                        $('#events-results-container').css('opacity', '1');
                        const offset = $('#events-results-container').offset().top - 100;
                        if(window.scrollY > offset) {
                            $('html, body').animate({
                                scrollTop: offset
                            }, 300);
                        }
                    }
                });
            };

            $(document).off('click', '.events-slider .wpisy-pagination button:not([disabled])').on('click', '.events-slider .wpisy-pagination button:not([disabled])', function (e) {
                e.preventDefault();
                const page = $(this).data('page');
                if (page) {
                    fetchEvents(page);
                }
            });

            updateActiveClasses();
            fetchEvents();

            $(document).on('change', '.event-filter-input', function () {
                const $this = $(this);
                
                if ($this.hasClass('event-najnowsze-trigger') && $this.is(':checked')) {
                    $('input[name="kategoria_wydarzenia[]"]').not('.event-najnowsze-trigger').prop('checked', false);
                    if (calendarInstance) {
                        isCalendarInit = true;
                        calendarInstance.setDate("today");
                        isCalendarInit = false;
                    }
                } else if (!$this.hasClass('event-najnowsze-trigger') && $this.is(':checked')) {
                    $('.event-najnowsze-trigger').prop('checked', false);
                }

                updateActiveClasses();
                fetchEvents();
            });

            $(document).on('click', '.filter-group-title', function () {
                $(this).closest('.filter-group').toggleClass('active');
            });

            $(document).on('click', '.open-filters', function () {
                $('#events-filters').toggleClass('active');
                $(this).find('.open-filters-text').toggleClass('d-none');
                $(this).find('.close-filters-text').toggleClass('d-none');
            });

            $searchBox.on('input', function () {
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(() => {
                    fetchEvents();
                }, 500);
            });
        },

        popupWydarzeniePost: function () {
            const $body = $('body');

            if ($('#wydarzenie-global-modal').length === 0) {
                $body.append(`
                    <div id="wydarzenie-global-modal" role="dialog" aria-modal="true" tabindex="-1" class="modal-overlay position-fixed top-0 start-0 w-100 h-100 d-none justify-content-center align-items-center" style="z-index: 99999999999999; background: rgba(0,0,0,0.75); backdrop-filter: blur(4px);">
                        <div class="bg-white rounded-4 position-relative w-100 mx-3 d-flex flex-column shadow-lg" style="max-width: 828px; max-height: 95vh;">
                            <button type="button" class="btn-close position-absolute top-0 end-0 m-4 js-close-wydarzenie-modal" aria-label="Close" style="z-index: 10;"></button>
                            <div class="modal-body text-modal overflow-auto p-3 p-lg-4">
                                <div class="wydarzenie-details-content"></div>
                            </div>
                        </div>
                    </div>
                `);
            }

            const $modal = $('#wydarzenie-global-modal');
            const $modalContent = $modal.find('.wydarzenie-details-content');

            $(document).on('click', '.js-open-wydarzenie-popup', function (e) {
                e.preventDefault();
                const targetId = $(this).data('target');
                const $sourceBlock = $('#' + targetId);

                if ($sourceBlock.length) {
                    $sourceBlock.removeClass('d-none');

                    const placeholderId = 'wydarzenie-placeholder-' + targetId;
                    if ($('#' + placeholderId).length === 0) {
                        $sourceBlock.before('<div id="' + placeholderId + '" class="d-none"></div>');
                    }

                    $modalContent.empty().append($sourceBlock);
                    $modal.removeClass('d-none').css('display', 'flex').hide().fadeIn(300);
                    $body.css('overflow', 'hidden');
                }
            });

            const closeModal = function () {
                $modal.fadeOut(300, function () {
                    $(this).addClass('d-none').css('display', '');
                    const $movedBlock = $modalContent.children().first();
                    if ($movedBlock.length) {
                        const originalId = $movedBlock.attr('id');
                        $movedBlock.addClass('d-none');
                        $('#wydarzenie-placeholder-' + originalId).replaceWith($movedBlock);
                    }
                    $modalContent.empty();
                    $body.css('overflow', '');
                });
            };

            $(document).on('click', '.js-close-wydarzenie-modal', closeModal);

            $modal.on('click', function (e) {
                if ($(e.target).is($modal)) {
                    closeModal();
                }
            });
        },

        kreatorEksperciSlider: function () {
            $('.kreator-experts-container').each(function () {
                var $container = $(this);
                var $slider = $container.find('.kreator-experts-slider');
                var $prev = $container.find('.btn-prev');
                var $next = $container.find('.btn-next');

                if ($slider.length && !$slider.hasClass('slick-initialized')) {
                    $slider.slick({
                        infinite: false,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        prevArrow: $prev,
                        nextArrow: $next,
                        dots: false,
                        responsive: [{
                                breakpoint: 1199,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                }
                            }
                        ]
                    });
                }
            });
        },

        sharePost: function () {
            $('#shareButton').on('click', function (e) {
                e.preventDefault();

                const $popup = $('#socialPopup');
                const currentUrl = encodeURIComponent(window.location.href);
                const $links = $popup.find('a');

                if ($links.length >= 3) {
                    $links.eq(0).attr('href', 'https://www.facebook.com/sharer/sharer.php?u=' + currentUrl);
                    $links.eq(1).attr('href', 'https://twitter.com/intent/tweet?url=' + currentUrl);
                    $links.eq(2).attr('href', 'https://www.linkedin.com/shareArticle?mini=true&url=' + currentUrl);
                }

                $popup.toggleClass('active');
            });
        },

        drawExpertiseConnections: function () {
            const draw = () => {
                const container = document.querySelector('.expertises-bottom-lines');
                const svg = document.getElementById('expertise-svg');
                const logo = document.getElementById('expertise-logo');
                const boxes = document.querySelectorAll('.expertise-box');

                if (!container || !svg || !logo || boxes.length === 0) return;

                svg.innerHTML = '';

                const containerRect = container.getBoundingClientRect();
                const logoRect = logo.getBoundingClientRect();
                const startX = (logoRect.left - containerRect.left) + (logoRect.width / 2);
                const startY = logoRect.bottom - containerRect.top;

                boxes.forEach(box => {
                    const boxRect = box.getBoundingClientRect();
                    const endX = (boxRect.left - containerRect.left) + (boxRect.width / 2);
                    const endY = boxRect.top - containerRect.top;
                    const controlX1 = startX;
                    const controlY1 = startY + (endY - startY) * 0.5;
                    const controlX2 = endX;
                    const controlY2 = startY + (endY - startY) * 0.5;

                    const pathString = `M ${startX} ${startY} C ${controlX1} ${controlY1}, ${controlX2} ${controlY2}, ${endX} ${endY}`;

                    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
                    path.setAttribute('d', pathString);
                    path.setAttribute('fill', 'none');
                    path.setAttribute('stroke', '#EB6411');
                    path.setAttribute('stroke-width', '1.5');
                    path.setAttribute('opacity', '0.3');

                    svg.appendChild(path);
                });
            };

            draw();
            $(window).on('resize', draw);
        },

        historyTabs: function () {
            const $tabsContainer = $('.history-tabs-scroll');
            const $tabs = $('.history-tab-item');
            const $panes = $('.history-content-pane');
            const $contentWrapper = $('.history-content-wrapper');
            const $btnPrev = $('.history-prev');
            const $btnNext = $('.history-next');

            if ($tabs.length === 0 || $panes.length === 0) return;

            $tabsContainer.css('position', 'relative');

            function activateTab(index) {
                if (index < 0 || index >= $tabs.length) return;

                $tabs.removeClass('active');
                $panes.removeClass('active');

                const $activeTab = $tabs.eq(index);
                const $activePane = $panes.eq(index);

                $activeTab.addClass('active');
                $activePane.addClass('active');

                const containerNode = $tabsContainer[0];
                const activeNode = $activeTab[0];

                const tabWidth = activeNode.offsetWidth;
                const containerWidth = containerNode.clientWidth;
                const tabLeft = activeNode.offsetLeft;

                const centeredScroll = tabLeft - (containerWidth / 2) + (tabWidth / 2);
                const tabsPerView = Math.max(1, Math.round(containerWidth / tabWidth));

                const maxK = Math.max(0, $tabs.length - tabsPerView);

                let k = Math.round(centeredScroll / tabWidth);
                k = Math.max(0, Math.min(k, maxK));

                if (index === k) {
                    $contentWrapper.addClass('first-active');
                } else {
                    $contentWrapper.removeClass('first-active');
                }

                if (index === k + tabsPerView - 1) {
                    $contentWrapper.addClass('last-active');
                } else {
                    $contentWrapper.removeClass('last-active');
                }

                const targetScroll = k * tabWidth;

                $tabsContainer.animate({
                    scrollLeft: targetScroll
                }, 400);
            }
            const initialIndex = $('.history-tab-item.active').index();
            if (initialIndex !== -1) {
                activateTab(initialIndex);
            } else {
                activateTab(0);
            }

            $tabs.on('click', function () {
                const index = $(this).index();
                activateTab(index);
            });

            $btnPrev.on('click', function (e) {
                e.preventDefault();
                let currentIndex = $('.history-tab-item.active').index();

                if (currentIndex > 0) {
                    activateTab(currentIndex - 1);
                } else {
                    activateTab($tabs.length - 1);
                }
            });

            $btnNext.on('click', function (e) {
                e.preventDefault();
                let currentIndex = $('.history-tab-item.active').index();

                if (currentIndex < $tabs.length - 1) {
                    activateTab(currentIndex + 1);
                } else {
                    activateTab(0);
                }
            });
        },

        opinieCarousel: function () {
            var $bgSlider = $('.opinie-bg-slider');
            var $contentSlider = $('.opinie-content-slider');

            if ($bgSlider.length === 0 || $contentSlider.length === 0) return;

            $bgSlider.on('init', function() {
                AOS.refresh();
            });

            $contentSlider.on('init', function() {
                AOS.refresh();
            });

            $bgSlider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                asNavFor: '.opinie-content-slider'
            });
            $contentSlider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                asNavFor: '.opinie-bg-slider',
                dots: true,
                arrows: false,
                focusOnSelect: true,
                appendDots: $('.opinie-dots-container'),
                customPaging: function (slider, i) {
                    return '<button type="button"></button>';
                }
            });

            var $modal = $('.opinie-modal');
            var $closeBtn = $('.opinie-modal-close');
            var $overlay = $('.opinie-modal-overlay');
            var $plusBtn = $('.opinie-plus-btn');
            $plusBtn.on('click', function (e) {
                e.preventDefault();
                var $currentSlide = $contentSlider.find('.slick-current');
                var wstep = $currentSlide.data('wstep');
                var content = $currentSlide.data('content');
                var tytul = $currentSlide.data('tytul');
                var pozycja = $currentSlide.data('pozycja');
                var img = $currentSlide.data('img');
                $modal.find('.modal-wstep').text(wstep);
                $modal.find('.modal-content-text').html(content);
                $modal.find('.modal-tytul').text(tytul);
                $modal.find('.modal-pozycja').text(pozycja);
                $modal.find('.modal-img').attr('src', img);

                $modal.fadeIn(300);
                $('body').css('overflow', 'hidden');
            });

            function closeModal() {
                $modal.fadeOut(300);
                $('body').css('overflow', '');
            }

            $closeBtn.on('click', closeModal);
            $overlay.on('click', closeModal);
        },

        drawConnections: function () {
            const draw = () => {
                const container = document.getElementById('diagram-container');
                const svg = document.getElementById('stats-svg');
                const logo = document.getElementById('diagram-logo');
                const boxes = document.querySelectorAll('.diagram-box');

                if (!container || !svg || !logo || boxes.length === 0) return;

                svg.innerHTML = '';

                const containerRect = container.getBoundingClientRect();
                const logoRect = logo.getBoundingClientRect();
                const startX = logoRect.right - containerRect.left;
                const startY = (logoRect.top - containerRect.top) + (logoRect.height / 2);

                boxes.forEach(box => {
                    const boxRect = box.getBoundingClientRect();
                    const endX = boxRect.left - containerRect.left;
                    const endY = (boxRect.top - containerRect.top) + (boxRect.height / 2);
                    const controlX1 = startX + (endX - startX) * 0.5;
                    const controlY1 = startY;
                    const controlX2 = startX + (endX - startX) * 0.5;
                    const controlY2 = endY;
                    const pathString = `M ${startX} ${startY} C ${controlX1} ${controlY1}, ${controlX2} ${controlY2}, ${endX} ${endY}`;

                    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
                    path.setAttribute('d', pathString);
                    path.setAttribute('fill', 'none');
                    path.setAttribute('stroke', '#EB6411');
                    path.setAttribute('stroke-width', '1.5');
                    path.setAttribute('opacity', '0.3');
                    svg.appendChild(path);
                });
            };
            draw();
            $(window).on('resize', draw);
        },

        eskperciSlider: function () {
            $('.experts-slider').slick({
                infinite: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                prevArrow: $('.experts-prev'),
                nextArrow: $('.experts-next'),
                dots: false,
                responsive: [{
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            });
        },

        showMoreText: function () {
            const expandButtons = document.querySelectorAll('.js-expand-btn');
            expandButtons.forEach(function (btn) {
                btn.addEventListener('click', function (e) {
                    e.preventDefault();
                    const parentBlock = this.closest('.typography');
                    const textContainer = parentBlock.querySelector('.expandable-text');

                    if (textContainer) {
                        textContainer.classList.remove('is-collapsed');
                    }
                    this.style.display = 'none';
                });
            });
        },

        navLinkPost: function () {
            const $navTop = $('.nav-top');
            const $navLinks = $('#inicjatywa-menu .nav-link');

            if ($navTop.length === 0 || $navLinks.length === 0) return;

            $navTop.addClass('sticky-top');
            $navTop.find('.sticky-top').removeClass('sticky-top');

            function setNavTop() {
                if ($(window).width() < 768) {
                    $navTop.css('top', '20px');
                } else {
                    $navTop.css('top', '50px');
                }
            }
            
            $navTop.css({
                'transition': 'box-shadow 0.3s ease'
            });
            
            setNavTop();
            $(window).on('resize', setNavTop);

            $navLinks.on('click', function (e) {
                e.preventDefault();
                const targetId = $(this).attr('href');
                const $targetSection = $(targetId);

                if ($targetSection.length) {
                    const navHeight = $navTop.outerHeight() || 0;

                    $('html, body').animate({
                        scrollTop: $targetSection.offset().top - navHeight - 45
                    }, 400);
                }
            });

            $(window).on('scroll', function () {
                const navHeight = $navTop.outerHeight() || 0;
                const windowScrollTop = $(window).scrollTop();

                const scrollPos = windowScrollTop + navHeight + 75;

                $navLinks.each(function () {
                    const $currLink = $(this);
                    const targetHref = $currLink.attr("href");

                    if (targetHref === "#") return;

                    const $refElement = $(targetHref);

                    if ($refElement.length) {
                        const refElementTop = $refElement.offset().top;
                        const refElementBottom = refElementTop + $refElement.outerHeight();

                        if (refElementTop <= scrollPos && refElementBottom > scrollPos) {
                            $navLinks.removeClass("active");
                            $currLink.addClass("active");
                        } else {
                            $currLink.removeClass("active");
                        }
                    }
                });
            });

            $(window).trigger('scroll');
        },

        partnersCarousel: function () {
            $('.partners-list').slick({
                infinite: true,
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: false,
                dots: true,
                customPaging: function (slider, i) {
                    return '<button type="button"></button>';
                },
                autoplay: true,
                speed: 1200,
                fade: false,
                cssEase: 'ease-in-out',
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        adaptiveHeight: true
                    }
                }]
            });
            $('.partners-edition-list').slick({
                infinite: true,
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                autoplay: true,
                speed: 500,
                fade: false,
                cssEase: 'ease-in-out',
                responsive: [{
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                            adaptiveHeight: true
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2
                        }
                    }
                ]
            });
        },

        downButton: function () {
            const downLinks = document.querySelectorAll('a[href="#down"]');
            downLinks.forEach(link => {
                link.addEventListener('click', function (e) {
                    e.preventDefault();
                    const elementBottom = this.getBoundingClientRect().bottom;
                    const targetScrollPosition = window.scrollY + elementBottom;
                    window.scrollTo({
                        top: targetScrollPosition,
                        behavior: 'smooth'
                    });
                });
            });
        },

        menuMobile: function () {
            const menuIcon = document.querySelector('.menu-icon-top');
            const closeMenu = document.querySelector('.close-menu');
            const menuContainer = document.querySelector('.menu-container');

            if (menuIcon && menuContainer) {
                menuIcon.addEventListener('click', () => {
                    menuContainer.classList.add('active');
                    document.body.classList.add('menu-active');
                });
            }

            if (closeMenu && menuContainer) {
                closeMenu.addEventListener('click', () => {
                    menuContainer.classList.remove('active');
                    document.body.classList.remove('menu-active');
                });
            }
        },

        agendaGoals: function () {
            const items = document.querySelectorAll('.acc-item');
            const container = document.querySelector('.accordion-container');

            items.forEach(item => {
                item.addEventListener('click', () => {
                    if (item.classList.contains('active')) return;

                    items.forEach(i => i.classList.remove('active'));
                    item.classList.add('active');

                    const bgImage = item.querySelector('.acc-content img');
                    if (container && bgImage) {
                        const currentBg = getComputedStyle(container).backgroundImage;

                        // 2. Tworzymy tymczasowy "fejkowy" kontener z obecnym tłem
                        const tempBg = document.createElement('div');
                        tempBg.style.position = 'absolute';
                        tempBg.style.top = '0';
                        tempBg.style.left = '0';
                        tempBg.style.width = '100%';
                        tempBg.style.height = '100%';
                        tempBg.style.backgroundImage = currentBg;
                        tempBg.style.backgroundPosition = 'center';
                        tempBg.style.backgroundSize = 'cover';
                        tempBg.style.zIndex = '0';
                        tempBg.style.transition = 'opacity 0.5s ease-in-out';

                        container.insertBefore(tempBg, container.firstChild);

                        container.style.backgroundImage = `url('${bgImage.src}')`;

                        requestAnimationFrame(() => {
                            tempBg.style.opacity = '0';
                        });

                        setTimeout(() => {
                            tempBg.remove();
                        }, 500);
                    }
                });
            });
        },

        charts: function () {
            const chartElements = document.querySelectorAll('.radial-chart');
            chartElements.forEach((el) => {
                const percentage = parseInt(el.dataset.percentage) || 0;
                const options = {
                    series: [percentage],
                    chart: {
                        height: 110,
                        width: 110,
                        type: 'radialBar',
                        parentHeightOffset: 0,
                        sparkline: {
                            enabled: true
                        }
                    },
                    grid: {
                        padding: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        }
                    },
                    plotOptions: {
                        radialBar: {
                            startAngle: 0,
                            endAngle: 360,
                            hollow: {
                                margin: 0,
                                size: '70%',
                                background: 'transparent',
                            },
                            track: {
                                background: 'rgba(255, 255, 255, 0.2)',
                                strokeWidth: '100%',
                                margin: 0,
                            },
                            dataLabels: {
                                show: true,
                                name: {
                                    show: false
                                },
                                value: {
                                    offsetY: 10,
                                    color: '#FFFFFF',
                                    fontSize: '24px',
                                    fontWeight: '400',
                                    show: true,
                                    formatter: function (val) {
                                        return val + '%';
                                    }
                                }
                            }
                        }
                    },
                    fill: {
                        colors: ['#EB6411'],
                    },
                    stroke: {
                        lineCap: 'round'
                    },
                    labels: ['Osiągnięto'],
                    responsive: [{
                        breakpoint: 1750,
                        options: {
                            chart: {
                                height: 74,
                                width: 74
                            },
                            plotOptions: {
                                radialBar: {
                                    dataLabels: {
                                        value: {
                                            fontSize: '14px',
                                            offsetY: 5
                                        }
                                    }
                                }
                            }
                        }
                    }]
                };

                const chart = new ApexCharts(el, options);
                chart.render();
            });
        },

        partnerzyAjax: function () {
            const $resultsContainer = $('#partnerzy-results-container');
            if (!$resultsContainer.length) return;

            const updateActiveClasses = () => {
                $('input[name="kategoria_partnera"]').parent().removeClass('active');
                $('input[name="kategoria_partnera"]:checked').parent().addClass('active');
            };

            const initPartnersSlider = () => {
                const $slider = $('.partners-slider');
                if ($slider.length) {
                    $slider.slick({
                        rows: 2,
                        slidesPerRow: 6,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true,
                        responsive: [{
                                breakpoint: 1200,
                                settings: {
                                    slidesPerRow: 5
                                }
                            },
                            {
                                breakpoint: 992,
                                settings: {
                                    slidesPerRow: 4
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesPerRow: 3
                                }
                            },
                            {
                                breakpoint: 576,
                                settings: {
                                    rows: 2,
                                    slidesPerRow: 2
                                }
                            }
                        ]
                    });
                }
            };

            const fetchPartnerzy = () => {
                const selectedCategory = $('input[name="kategoria_partnera"]:checked').val();
                const data = {
                    action: 'filter_partnerzy',
                    nonce: wiedza_vars.nonce,
                    kategoria: selectedCategory
                };

                $resultsContainer.css('opacity', '0.5');

                $.ajax({
                    url: wiedza_vars.ajax_url,
                    type: 'POST',
                    data: data,
                    success: function (response) {
                        if (response.success) {
                            $resultsContainer.html(response.data.html);
                            initPartnersSlider();
                        } else {
                            $resultsContainer.html('<p class="text-center">Brak partnerów w tej kategorii.</p>');
                        }
                    },
                    error: function () {
                        $resultsContainer.html('<p class="text-center text-danger">Błąd połączenia.</p>');
                    },
                    complete: function () {
                        $resultsContainer.css('opacity', '1');
                    }
                });
            };

            updateActiveClasses();
            fetchPartnerzy();

            $(document).on('change', '.partner-filter-input', function () {
                updateActiveClasses();
                fetchPartnerzy();
            });
        },

celeAjax: function () {
    const $container = $('.cele-list-container');
    const $detailsWrapper = $('#cel-details-wrapper');
    const $detailsContent = $('#cel-details-content');
    const $loader = $detailsWrapper.find('.cel-loader');
    
    if (!$container.length) return;

    function updateNavColors() {
        const $active = $('.cel-list-item.active');
        const $prev = $active.prev('.cel-list-item');
        const $next = $active.next('.cel-list-item');

        const prevColor = $prev.length && $prev.data('color') ? $prev.data('color') : 'white';

        let nextColor = 'white';
        if ($next.length && $next.data('color')) {
            nextColor = $next.data('color');
        } else {
            const $first = $('.cel-list-item').first();
            if ($first.length && $first.data('color')) {
                nextColor = $first.data('color');
            }
        }

        $('.nav-left rect').attr('fill', prevColor);
        $('.nav-right rect').attr('fill', nextColor);
    }

    function przełączCel(kierunek) {
        const $activeItem = $('.cel-list-item.active');
        let $targetItem;

        if (kierunek === 'nastepny') {
            $targetItem = $activeItem.next('.cel-list-item');
            if (!$targetItem.length) {
                $targetItem = $('.cel-list-item').first();
            }
        } else if (kierunek === 'poprzedni') {
            $targetItem = $activeItem.prev('.cel-list-item');
            if (!$targetItem.length) {
                $targetItem = $('.cel-list-item').last();
            }
        }

        if ($targetItem && $targetItem.length) {
            $targetItem.trigger('click');
        }
    }

    $(document).on('click', '.cel-list-item', function (e) {
        e.preventDefault();
        const $this = $(this);
        const postId = $this.data('id');
        
        if ($this.hasClass('active')) return;

        $('.cel-list-item').removeClass('active');
        $this.addClass('active');

        const itemTop = $this.offset().top - $container.offset().top;
        const itemHeight = $this.outerHeight();
        const containerHeight = $container.innerHeight();
        const currentScroll = $container.scrollTop();
        const gap = parseInt($container.css('gap')) || 0;
        const buffer = 0;

        if (itemTop < gap) {
            $container.animate({
                scrollTop: currentScroll + itemTop - gap - buffer
            }, 300);
        } else if (itemTop + itemHeight > containerHeight) {
            $container.animate({
                scrollTop: currentScroll + (itemTop + itemHeight - containerHeight) + gap + buffer
            }, 300);
        }

        $detailsContent.css('opacity', '0.2');
        $loader.show();

        $.ajax({
            url: wiedza_vars.ajax_url,
            type: 'POST',
            data: {
                action: 'load_cel_details',
                nonce: wiedza_vars.nonce,
                post_id: postId
            },
            success: function (response) {
                if (response.success) {
                    $detailsContent.html(response.data.html);
                    updateNavColors();
                } else {
                    $detailsContent.html('<p class="text-center text-danger">Wystąpił błąd podczas ładowania danych.</p>');
                }
            },
            error: function () {
                $detailsContent.html('<p class="text-center text-danger">Błąd połączenia.</p>');
            },
            complete: function () {
                $loader.hide();
                $detailsContent.css('opacity', '1');
            }
        });
    });

    $(document).on('click', '.nav-cel .nav-left', function (e) {
        e.preventDefault();
        przełączCel('poprzedni');
    });

    $(document).on('click', '.nav-cel .nav-right', function (e) {
        e.preventDefault();
        przełączCel('nastepny');
    });
},

        wpisyAjax: function () {
            const $resultsContainer = $('#wpisy-results-container');
            if (!$resultsContainer.length) return;

            const fetchPosts = (page = 1) => {
                const data = {
                    action: 'filter_wpisy',
                    nonce: wiedza_vars.nonce,
                    kategoria: $('input[name="kategoria"]:checked').val(),
                    paged: page
                };

                $resultsContainer.css('opacity', '0.5');

                $.ajax({
                    url: wiedza_vars.ajax_url,
                    type: 'POST',
                    data: data,
                    success: function (response) {
                        if (response.success) {
                            $resultsContainer.html(response.data.html);
                        } else {
                            $resultsContainer.html('<p class="text-center">Wystąpił błąd.</p>');
                        }
                    },
                    complete: function () {
                        $resultsContainer.css('opacity', '1');
                        const offset = $resultsContainer.offset().top - 100;
                        if(window.scrollY > offset) {
                            $('html, body').animate({
                                scrollTop: offset
                            }, 300);
                        }
                    }
                });
            };
            fetchPosts(1);
            
            $(document).off('change', '.wpisy-filter-input').on('change', '.wpisy-filter-input', function () {
                fetchPosts(1);
            });
            
            $(document).off('click', '.wpisy-pagination button:not([disabled])').on('click', '.wpisy-pagination button:not([disabled])', function (e) {
                e.preventDefault();
                const page = $(this).data('page');
                if (page) {
                    fetchPosts(page);
                }
            });
        },

        opinieSlider: function () {
            $('.testimonials-slider').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                autoplay: false,
                speed: 500,
                fade: false,
                cssEase: 'ease-in-out',
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        adaptiveHeight: true
                    }
                }]
            });
            $('.slick-custom-prev').click(function (e) {
                e.preventDefault();
                $('.testimonials-slider').slick('slickPrev');
            });
            $('.slick-custom-next').click(function (e) {
                e.preventDefault();
                $('.testimonials-slider').slick('slickNext');
            });
        },

        menuSubmenuShow: function () {
            $('li.menu-item-has-children').hover(
                function () {
                    if (window.innerWidth > 991) {
                        $(this).addClass('active');
                        $(this).find('> ul.sub-menu').addClass('active');
                    }
                },
                function () {
                    if (window.innerWidth > 991) {
                        $(this).removeClass('active');
                        $(this).find('> ul.sub-menu').removeClass('active');
                    }
                }
            );

            $('li.menu-item-has-children > a').on('click', function (e) {
                if (window.innerWidth <= 991) {
                    var $parent = $(this).parent();
                    if (!$parent.hasClass('active')) {
                        e.preventDefault();
                        $('li.menu-item-has-children').not($parent).removeClass('active');
                        $('li.menu-item-has-children').not($parent).find('> ul.sub-menu').removeClass('active');
                        $parent.addClass('active');
                        $parent.find('> ul.sub-menu').addClass('active');
                    }
                }
            });
        },

        popupKnowledge: function () {
            const $body = $('body');

            if ($('#knowledge-global-modal').length === 0) {
                $body.append(`
                        <div id="knowledge-global-modal" role="dialog" aria-modal="true" tabindex="-1" class="modal-overlay position-fixed top-0 start-0 w-100 h-100 d-none justify-content-center align-items-center" style="z-index: 99999999999999; background: rgba(0,0,0,0.75); backdrop-filter: blur(4px);">
                            <div class="bg-white rounded-4 position-relative w-100 mx-3 d-flex flex-column shadow-lg" style="max-width: 828px; max-height: 95vh;">
                                <button type="button" class="btn-close position-absolute top-0 end-0 m-4 js-close-knowledge-modal" aria-label="Close" style="z-index: 10;"></button>
                                <div class="modal-body text-modal overflow-auto p-3 p-lg-4">
                                    <div class="knowledge-details-content"></div>
                                </div>
                            </div>
                        </div>
                    `);
            }

            const $modal = $('#knowledge-global-modal');
            const $modalContent = $modal.find('.knowledge-details-content');

            $(document).on('click', '.js-open-knowledge-popup', function (e) {
                e.preventDefault();
                const targetId = $(this).data('target');
                const $sourceBlock = $('#' + targetId);

                if ($sourceBlock.length) {
                    $sourceBlock.removeClass('d-none');

                    const placeholderId = 'knowledge-placeholder-' + targetId;
                    if ($('#' + placeholderId).length === 0) {
                        $sourceBlock.before('<div id="' + placeholderId + '" class="d-none"></div>');
                    }

                    $modalContent.empty().append($sourceBlock);
                    $modal.removeClass('d-none').css('display', 'flex').hide().fadeIn(300);
                    $body.css('overflow', 'hidden');
                }
            });

            const closeModal = function () {
                $modal.fadeOut(300, function () {
                    $(this).addClass('d-none').css('display', '');
                    const $movedBlock = $modalContent.children().first();
                    if ($movedBlock.length) {
                        const originalId = $movedBlock.attr('id');
                        $movedBlock.addClass('d-none');
                        $('#knowledge-placeholder-' + originalId).replaceWith($movedBlock);
                    }
                    $modalContent.empty();
                    $body.css('overflow', '');
                });
            };

            $(document).on('click', '.js-close-knowledge-modal', closeModal);

            $modal.on('click', function (e) {
                if ($(e.target).is($modal)) {
                    closeModal();
                }
            });
        },

        wiedzaAjax: function () {
            const $resultsContainer = $('#wiedza-results-container');
            const $searchBox = $('#wiedza-search-input');
            const $navigationRow = $('.row.navigation');

            if (!$resultsContainer.length) return;

            let debounceTimer;

            const updateActiveClasses = () => {
                $('#wiedza-filters label, .tags-list label').removeClass('active');
                $('#wiedza-filters input:checked, .tags-list input:checked').parent('label').addClass('active');
            };

            const getCheckedValues = (name) => {
                return $('input[name="'+name+'"]:checked').map(function() {
                    return $(this).val();
                }).get().filter(val => val !== "");
            };

            const fetchPosts = (page = 1) => {
                const data = {
                    action: 'filter_wiedza',
                    nonce: wiedza_vars.nonce,
                    search: $searchBox.val(),
                    kategoria: $('input[name="kategoria"]:checked').val(),
                    tag_wiedzy: getCheckedValues('tag_wiedzy'),
                    rok: getCheckedValues('rok'),
                    cel: getCheckedValues('cel'),
                    branza: getCheckedValues('branza'),
                    partner: getCheckedValues('partner'),
                    paged: page
                };

                $resultsContainer.css('opacity', '0.5');

                $.ajax({
                    url: wiedza_vars.ajax_url,
                    type: 'POST',
                    data: data,
                    success: function (response) {
                        $navigationRow.addClass('d-none').hide(); // Ukrywamy stary wiersz nawigacji
                        
                        if (response.success) {
                            $resultsContainer.html(response.data.html);
                        } else {
                            $resultsContainer.html('<p class="text-center w-100 py-5">Wystąpił błąd.</p>');
                        }
                    },
                    complete: function () {
                        $resultsContainer.css('opacity', '1');
                        const offset = $resultsContainer.offset().top - 100;
                        if(window.scrollY > offset) {
                            $('html, body').animate({
                                scrollTop: offset
                            }, 300);
                        }
                    }
                });
            };

            $(document).off('click', '#wiedza-results-container .wpisy-pagination button:not([disabled])').on('click', '#wiedza-results-container .wpisy-pagination button:not([disabled])', function (e) {
                e.preventDefault();
                const page = $(this).data('page');
                if (page) {
                    fetchPosts(page);
                }
            });

            updateActiveClasses();
            $('.wiedza-filter-input:checked').data('waschecked', true);
            fetchPosts();

            $(document).on('click', '.wiedza-filter-input', function (e) {
                const $this = $(this);
                const name = $this.attr('name');
                const val = $this.val();
                const type = $this.attr('type');

                if (type === 'radio') {
                    if (val === '') {
                        $(`input[name="${name}"]`).prop('checked', false).data('waschecked', false);
                        $(`input[name="${name}"][value=""]`).prop('checked', true).data('waschecked', true);
                        return;
                    }

                    if ($this.data('waschecked') === true) {
                        $(`input[name="${name}"]`).prop('checked', false).data('waschecked', false);
                        $(`input[name="${name}"][value=""]`).prop('checked', true).data('waschecked', true);

                        updateActiveClasses();
                        fetchPosts();
                    } else {
                        $(`input[name="${name}"]`).prop('checked', false).data('waschecked', false);
                        $(`input[name="${name}"][value="${val}"]`).prop('checked', true).data('waschecked', true);
                    }
                }
            });

            $(document).on('change', '.wiedza-filter-input', function () {
                const $this = $(this);
                const name = $this.attr('name');
                const val = $this.val();
                const type = $this.attr('type');

                if (name === 'kategoria') {
                    if (val === '') {
                        $('.results-top .left-side h2').html('Najnowsze w <strong>bazie wiedzy</strong>');
                    } else {
                        const clone = $this.next('span').clone();
                        clone.find('.icon').remove();
                        const cleanText = clone.text().trim();
                        $('.results-top .left-side h2').html('Najnowsze <strong>' + cleanText + '</strong>');
                    }
                }

                if (type === 'radio') {
                    $(`input[name="${name}"]`).prop('checked', false).data('waschecked', false);
                    $(`input[name="${name}"][value="${val}"]`).prop('checked', true).data('waschecked', true);
                } else if (type === 'checkbox') {
                    if (val === '') {
                        $(`input[name="${name}"]`).prop('checked', false);
                        $this.prop('checked', true);
                    } else {
                        $(`input[name="${name}"][value=""]`).prop('checked', false);
                        if ($(`input[name="${name}"]:checked`).length === 0) {
                             $(`input[name="${name}"][value=""]`).prop('checked', true);
                        }
                    }
                }

                updateActiveClasses();
                fetchPosts();
            });

            $(document).on('click', '#wiedza-filters .filter-group-title', function () {
                $(this).closest('.filter-group').toggleClass('active');
            });

            $(document).on('click', '.open-filters', function () {
                $('#wiedza-filters').toggleClass('active');
                $(this).find('.open-filters-text').toggleClass('d-none');
                $(this).find('.close-filters-text').toggleClass('d-none');
            });

            $searchBox.on('input', function () {
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(() => {
                    fetchPosts();
                }, 500);
            });
        },
inicjatywaAjax: function () {
    const $resultsContainer = $('#inicjatywa-results-container');
    if (!$resultsContainer.length) return;

    const updateActiveClasses = () => {
        $('input[name="rok"]').parent().removeClass('active');
        const $checkedYear = $('input[name="rok"]:checked');
        if ($checkedYear.length && $checkedYear.val() !== '') {
            $checkedYear.parent().addClass('active');
        }

        $('input[name="status"]').closest('.toggle-pill-wrapper').removeClass('active');
        if ($('input[name="status"]').is(':checked')) {
            $('input[name="status"]').closest('.toggle-pill-wrapper').addClass('active');
        }
    };

    const fetchPosts = (page = 1) => {
        const data = {
            action: 'filter_inicjatywa',
            nonce: wiedza_vars.nonce,
            kategoria: $('input[name="kategoria"]:checked').val(),
            status: $('input[name="status"]').is(':checked') ? $('input[name="status"]').val() : '',
            rok: $('input[name="rok"]:checked').val(),
            cel: $('input[name="cel"]:checked').val(),
            partner: $('input[name="partner"]:checked').val(),
            paged: page
        };

        $resultsContainer.css('opacity', '0.5');

        $.ajax({
            url: wiedza_vars.ajax_url,
            type: 'POST',
            data: data,
            success: function (response) {
                $('.row.navigation').addClass('d-none').hide(); // Ukrywamy stary wiersz nawigacji jeśli jest zewn.
                
                if (response.success) {
                    $resultsContainer.html(response.data.html);

                    $('#ajax-inicjatywa-popups-wrapper').remove();
                    if (response.data.popups) {
                        $('body').append('<div id="ajax-inicjatywa-popups-wrapper" class="d-none">' + response.data.popups + '</div>');
                    }
                } else {
                    $resultsContainer.html('<p class="text-center">Wystąpił błąd.</p>');
                }
            },
            complete: function () {
                $resultsContainer.css('opacity', '1');
                const offset = $resultsContainer.offset().top - 100;
                if(window.scrollY > offset) {
                    $('html, body').animate({
                        scrollTop: offset
                    }, 300);
                }
            }
        });
    };

    $(document).off('click', '#inicjatywa-results-container .wpisy-pagination button:not([disabled])').on('click', '#inicjatywa-results-container .wpisy-pagination button:not([disabled])', function (e) {
        e.preventDefault();
        const page = $(this).data('page');
        if (page) {
            fetchPosts(page);
        }
    });

    $('input[type="radio"]:checked').data('was-checked', true);
    updateActiveClasses();
    fetchPosts();

    $(document).on('change', '.inicjatywa-filter-input', function () {
        if ($(this).attr('type') === 'radio') {
            var name = $(this).attr('name');
            $('input[name="' + name + '"]').data('was-checked', false);
            $(this).data('was-checked', true);
        }

        updateActiveClasses();
        fetchPosts();
    });

    $(document).on('click', 'input[name="rok"]', function (e) {
        var $this = $(this);
        var name = $this.attr('name');
        if ($this.val() === '') return;
        if ($this.data('was-checked') === true) {
            $this.prop('checked', false);
            $this.data('was-checked', false);
            $('input[name="' + name + '"][value=""]').prop('checked', true).data('was-checked', true);

            updateActiveClasses();
            fetchPosts();
        }
    });

    $(document).on('change', '.accordion-collapse .inicjatywa-filter-input', function () {
        $('#contextAccordion .accordion-button').removeClass('fw-bold text-primary');
        $('#contextAccordion .accordion-collapse').each(function () {
            if ($(this).find('input:checked').length > 0 && $(this).find('input:checked').val() !== '') {
                $(this).prev('.accordion-header').find('.accordion-button').addClass('fw-bold text-primary');
            }
        });
    });
},

popupInicjatywaPost: function(){
    const $body = $('body');

    if ($('#inicjatywa-global-modal').length === 0) {
        $body.append(`
            <div id="inicjatywa-global-modal" role="dialog" aria-modal="true" tabindex="-1" class="modal-overlay position-fixed top-0 start-0 w-100 h-100 d-none justify-content-center align-items-center" style="z-index: 99999999999999; background: rgba(0,0,0,0.75); backdrop-filter: blur(4px);">
                <div class="bg-white rounded-4 position-relative w-100 mx-3 d-flex flex-column shadow-lg" style="max-width: 828px; max-height: 95vh;">
                    <button type="button" class="btn-close position-absolute top-0 end-0 m-4 js-close-inicjatywa-modal" aria-label="Close" style="z-index: 10;"></button>
                    <div class="modal-body text-modal overflow-auto p-3 p-lg-4">
                        <div class="inicjatywa-details-content"></div>
                    </div>
                </div>
            </div>
        `);
    }

    const $modal = $('#inicjatywa-global-modal');
    const $modalContent = $modal.find('.inicjatywa-details-content');

    $(document).on('click', '.js-open-inicjatywa-popup', function (e) {
        e.preventDefault();
        const targetId = $(this).data('target');
        const $sourceBlock = $('#' + targetId);

        if ($sourceBlock.length) {
            $sourceBlock.removeClass('d-none');
            
            const placeholderId = 'inicjatywa-placeholder-' + targetId;
            if ($('#' + placeholderId).length === 0) {
                $sourceBlock.before('<div id="' + placeholderId + '" class="d-none"></div>');
            }
            
            $modalContent.empty().append($sourceBlock);
            $modal.removeClass('d-none').css('display', 'flex').hide().fadeIn(300);
            $body.css('overflow', 'hidden');
        }
    });

    const closeModal = function () {
        $modal.fadeOut(300, function () {
            $(this).addClass('d-none').css('display', '');
            const $movedBlock = $modalContent.children().first();
            if ($movedBlock.length) {
                const originalId = $movedBlock.attr('id');
                $movedBlock.addClass('d-none');
                $('#inicjatywa-placeholder-' + originalId).replaceWith($movedBlock);
            }
            $modalContent.empty();
            $body.css('overflow', '');
        });
    };

    $(document).on('click', '.js-close-inicjatywa-modal', closeModal);

    $modal.on('click', function (e) {
        if ($(e.target).is($modal)) {
            closeModal();
        }
    });
    },

        initAccessibility: function() {
            let lastFocusedElement = null;

            $(document).on('click', '[class*="js-open-"]', function(e) {
                lastFocusedElement = document.activeElement;
            });

            $(document).on('click', '.btn-close', function(e) {
                if (lastFocusedElement) {
                    setTimeout(() => {
                        lastFocusedElement.focus();
                    }, 310);
                }
            });

            $(document).on('keydown', function(e) {
                const $visibleModal = $('.modal-overlay:visible');
                if ($visibleModal.length) {
                    if (e.key === 'Escape') {
                        $visibleModal.find('.btn-close').click();
                    } else if (e.key === 'Tab') {
                        const focusableElements = $visibleModal.find('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])');
                        if (focusableElements.length === 0) return;
                        
                        const firstElement = focusableElements.first()[0];
                        const lastElement = focusableElements.last()[0];

                        if (e.shiftKey) {
                            if (document.activeElement === firstElement || document.activeElement === document.body) {
                                lastElement.focus();
                                e.preventDefault();
                            }
                        } else {
                            if (document.activeElement === lastElement) {
                                firstElement.focus();
                                e.preventDefault();
                            }
                        }
                    }
                }
            });
        }
    }
})(jQuery)
